import React from 'react';
import { Download, Check, AlertCircle, Loader2 } from 'lucide-react';
import { cn } from '../../lib/utils';

/**
 * Indicateur de progression de téléchargement - inline et compact.
 */
export function DownloadProgress({ status, progress = 0, className }) {
  if (!status) return null;
  
  if (status === 'done') {
    return (
      <span className={cn("inline-flex items-center gap-1 text-emerald-600 text-xs font-medium animate-in fade-in duration-300", className)}>
        <Check className="h-3.5 w-3.5" />
      </span>
    );
  }
  
  if (status === 'error') {
    return (
      <span className={cn("inline-flex items-center gap-1 text-red-500 text-xs", className)}>
        <AlertCircle className="h-3.5 w-3.5" />
      </span>
    );
  }
  
  // Loading
  return (
    <span className={cn("inline-flex items-center gap-1.5 text-xs text-blue-600", className)}>
      <Loader2 className="h-3.5 w-3.5 animate-spin" />
      <span className="font-mono tabular-nums">{progress}%</span>
    </span>
  );
}

/**
 * Barre de progression horizontale pour les téléchargements.
 */
export function DownloadProgressBar({ status, progress = 0, filename, className }) {
  if (!status || status === 'done') return null;
  
  return (
    <div className={cn("flex items-center gap-2 px-3 py-1.5 bg-blue-50 rounded-md border border-blue-100", className)}
         data-testid="download-progress-bar">
      <Download className="h-3.5 w-3.5 text-blue-500 shrink-0" />
      <div className="flex-1 min-w-0">
        {filename && (
          <p className="text-[11px] text-blue-700 truncate">{filename}</p>
        )}
        <div className="h-1 w-full bg-blue-100 rounded-full overflow-hidden mt-0.5">
          <div
            className="h-full bg-blue-500 rounded-full transition-all duration-200 ease-out"
            style={{ width: `${Math.max(progress, 2)}%` }}
          />
        </div>
      </div>
      <span className="text-[10px] font-mono text-blue-600 tabular-nums shrink-0">{progress}%</span>
    </div>
  );
}
